// extracted by mini-css-extract-plugin
export default {"cls1":"CenteredDiv-cls1___904eb07ac9280523f79","cls2":"CenteredDiv-cls2___77d9ebe437b959700a7 CenteredDiv-cls1___904eb07ac9280523f79"};